import { DropdownMenuItem } from "visuais"
import { Column } from "@tanstack/react-table"
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react"

export function ColunaOrdenacao({ column }: { column: Column<any, unknown> }) {
  const sortDirection = column.getIsSorted()

  return (
    <>
      <DropdownMenuItem
        onClick={() => column.toggleSorting(false)}
        className="flex items-center gap-2"
      >
        <ArrowUp className="h-3 w-3" />
        Ordenar Crescente
        {sortDirection === "asc" && (
          <span className="ml-auto text-blue-600">✓</span>
        )}
      </DropdownMenuItem>

      <DropdownMenuItem
        onClick={() => column.toggleSorting(true)}
        className="flex items-center gap-2"
      >
        <ArrowDown className="h-3 w-3" />
        Ordenar Decrescente
        {sortDirection === "desc" && (
          <span className="ml-auto text-blue-600">✓</span>
        )}
      </DropdownMenuItem>

      {sortDirection && (
        <DropdownMenuItem
          onClick={() => column.clearSorting()}
          className="flex items-center gap-2"
        >
          <ArrowUpDown className="h-3 w-3" />
          Remover Ordenação
        </DropdownMenuItem>
      )}
    </>
  )
}